export var DiaSemana;
(function (DiaSemana) {
    DiaSemana["SEGUNDA"] = "SEGUNDA";
    DiaSemana["TERCA"] = "TERCA";
    DiaSemana["QUARTA"] = "QUARTA";
    DiaSemana["QUINTA"] = "QUINTA";
    DiaSemana["SEXTA"] = "SEXTA";
    DiaSemana["SABADO"] = "SABADO";
    DiaSemana["DOMINGO"] = "DOMINGO";
})(DiaSemana || (DiaSemana = {}));
